import { render, staticRenderFns } from "./integrateSearch.vue?vue&type=template&id=2774e6f0"
import script from "./integrateSearch.vue?vue&type=script&lang=js"
export * from "./integrateSearch.vue?vue&type=script&lang=js"
import style0 from "./integrateSearch.vue?vue&type=style&index=0&id=2774e6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports